import ReadyInfo from '@src/components/ReadyInfo'
import React from 'react'
import { useTranslation } from 'react-i18next'

const SuccessPage = (): JSX.Element => {
  const { t } = useTranslation('repairshop')
  return (
    <ReadyInfo
      imageBaseName="ready"
      title={t('success-page.title')}
      text={t('success-page.info')}
    />
  )
}

export default SuccessPage
